/* istanbul ignore file */

export const UNAMUSED = "unamused";
export const DOH = "doh";
export const DISAPPOINTED = "disappointed";
